import script from "./cambioContraseña.vue?vue&type=script&setup=true&lang=js"
export * from "./cambioContraseña.vue?vue&type=script&setup=true&lang=js"

import "@/assets/plantilla/style.css?vue&type=style&index=0&id=48c6474b&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48c6474b"]])

export default __exports__